import { createAction, props } from '@ngrx/store';
import { IJobOfferState } from './job-offer.state';

export const initJobOfferAction = createAction('[JobOffer Page] JobOffer page');

export const setJobOfferAction = createAction(
  '[JobOffer Page] set data',
  props<IJobOfferState>()
);
